import SinglePage, { Paragraph } from "../single-page/single-page";
import { PricesSubpage } from "../home-page/landing/landing";
import { singlePrice } from "../../envs";
import { Helmet } from "react-helmet";

function Prices() {
    return (
        <SinglePage title="Cennik">
            <Helmet>
                <title>Cennik - Wyszukiwanie numerów ksiąg wieczystych</title>
                <meta
                    name="description"
                    content="Nasz serwis umożliwia szybkie i wygodne wyszukiwanie numerów ksiąg wieczystych. Poznaj nasze atrakcyjne pakiety oraz jednorazowe ceny, dzięki którym odkrywanie numerów ksiąg staje się prostsze."
                />
                <meta
                    name="keywords"
                    content="cennik, numer księgi wieczystej, wyszukiwanie ksiąg wieczystych, pakiety, ceny, wyszukiwanie nieruchomości"
                />
            </Helmet>
            <Paragraph>
                Nasz serwis umożliwia szybkie i wygodne wyszukiwanie numerów ksiąg wieczystych. <br />
                Jeśli potrzebujesz jednorazowo pozyskać numer księgi, możesz to zrobić bez konieczności
                zakładania konta czy logowania – pojedynczy numer kosztuje jedynie{" "}
                <strong>{singlePrice} zł</strong>.
            </Paragraph>
            <Paragraph>
                Dla użytkowników zalogowanych oferujemy atrakcyjne pakiety, dzięki którym odkrywanie numerów
                ksiąg wieczystych staje się jeszcze bardziej opłacalne.
            </Paragraph>
            <Paragraph>
                Zachęcamy do zapoznania się z cenami pakietów podanymi poniżej.
            </Paragraph>
            <PricesSubpage title="Dostępne pakiety odkryć" />
        </SinglePage>
    );
}

export default Prices;
